export const SPECIAL_LOCATIONS = ["community", "aktuelles"]
let isRedirecting = false
export function possibleRedirectToSpecialLocation(href: string, slug: string) {
    if (isRedirecting) {
        return true
    }
    const specialLocation = urlEndsWithSpecialLocation(href)
    if (specialLocation) {
        const pathSplits = [slug, specialLocation].filter((l) => l !== undefined && l !== "")
        isRedirecting = true
        window.location.href = `/${pathSplits.join("/")}`
        return true
    }

    return false
}

export function setIsRedirectingToSpecialLocation(r: boolean) {
    isRedirecting = r
}

export function urlEndsWithSpecialLocation(href: string) {
    let url = href
    if (url.endsWith("/")) {
        url = url.slice(0, -1)
    }
    // it seems only /community and /aktuelles have a special location redirect. Even on home (e. g. /berlin) there is a redirect to /berlin/sex-anzeigen when searching for a location:)
    let endsWithSpecialLocation = ""
    for (let i = 0; i < SPECIAL_LOCATIONS.length; i++) {
        if (url.endsWith(SPECIAL_LOCATIONS[i])) {
            endsWithSpecialLocation = SPECIAL_LOCATIONS[i]
            break
        }
    }
    return endsWithSpecialLocation
}
